import { render, staticRenderFns } from "./MenuAnalitic.vue?vue&type=template&id=06bb484c&scoped=true"
import script from "./MenuAnalitic.vue?vue&type=script&lang=js"
export * from "./MenuAnalitic.vue?vue&type=script&lang=js"
import style0 from "./MenuAnalitic.vue?vue&type=style&index=0&id=06bb484c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bb484c",
  null
  
)

export default component.exports